export const Vacation = () => (
  <svg width="61" height="61">
    <defs>
      <path id="a" d="M0 .607h60.358V60.29H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(0 .103)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          d="M30.18 2.213c-7.631 0-14.806 2.937-20.203 8.27-11.138 11.01-11.138 28.923 0 39.932 5.397 5.333 12.572 8.27 20.202 8.27 7.63 0 14.805-2.937 20.202-8.27 11.138-11.01 11.138-28.923 0-39.932-5.397-5.333-12.571-8.27-20.202-8.27m0 58.078c-8.065 0-15.648-3.105-21.35-8.74-11.772-11.636-11.772-30.568 0-42.204C14.531 3.711 22.114.607 30.18.607c8.065 0 15.648 3.104 21.35 8.74 11.772 11.636 11.772 30.568 0 42.203-5.702 5.636-13.285 8.74-21.35 8.74"
          fill="#FFF"
          mask="url(#b)"
        />
      </g>
      <path
        d="M33.92 49.328h-7.06c-4.736 0-8.611-3.83-8.611-8.512v-13.42c0-4.68 3.875-8.511 8.612-8.511h7.06c4.736 0 8.612 3.83 8.612 8.512v13.419c0 4.681-3.876 8.512-8.612 8.512z"
        stroke="#FFF"
        strokeWidth="2"
      />
      <path
        stroke="#FFF"
        strokeWidth="1.5"
        d="M24.202 18.604h2.146v-6.867h-2.146zM34.551 18.604h2.147v-6.867H34.55zM36.814 11.6H23.898a1.352 1.352 0 0 1-1.355-1.34c0-.738.61-1.34 1.355-1.34h12.916c.745 0 1.356.602 1.356 1.34 0 .736-.61 1.34-1.356 1.34zM25.575 52.884a1.37 1.37 0 0 1-1.373-1.357v-.562c0-.746.618-1.356 1.373-1.356s1.373.61 1.373 1.356v.562a1.37 1.37 0 0 1-1.373 1.357zM35.625 52.884a1.37 1.37 0 0 1-1.373-1.357v-.562c0-.746.618-1.356 1.373-1.356.754 0 1.372.61 1.372 1.356v.562a1.37 1.37 0 0 1-1.372 1.357z"
      />
      <path
        d="M25.275 26.086v16.882M35.363 26.086v16.882"
        stroke="#FFF"
        strokeWidth="2"
      />
    </g>
  </svg>
);
